/**
 * previewAuth.ts — §9.1 (2026-09-05): mint the preview-door cookie.
 *
 * `/api/preview/<id>/<path>` is gated in-handler by a short-lived signed cookie
 * (routes/preview.py). An <img src>, the preview iframe, `window.open` and a
 * same-origin `fetch` all carry it automatically — none of them can carry the
 * Bearer, which is why the door was ever open. The cookie is minted through the
 * Bearer-gated `POST /api/preview-authorize` (services/api attaches the JWT).
 *
 * Single-flight: concurrent callers share one in-flight POST; once settled a
 * later call mints again (the cookie lives 3600 s server-side; AuthProvider
 * re-mints on every token refresh and on PREVIEW_COOKIE_REMINT_MS).
 */
import { api } from './api';

/** Re-mint cadence — must be inside the backend's COOKIE_TTL_SECONDS (3600). */
export const PREVIEW_COOKIE_REMINT_MS = 45 * 60 * 1000;

let inflight: Promise<void> | null = null;

export function ensurePreviewCookie(): Promise<void> {
  if (inflight) return inflight;
  inflight = api
    .post<void>('/preview-authorize')
    .then(() => undefined)
    .finally(() => {
      inflight = null;
    });
  return inflight;
}
